import H2 from '@base/H2/H2';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import Layout from '@layout/index';
import { Spacings, mediaQuery } from '@styles/index';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const Wrapper = styled.div`
  grid-column: span 25;
  ${mediaQuery.uptoTablet} {
    padding: ${Spacings.SPACING_12B};
    align-items: center;
  }
`;

const StyledH2 = styled(H2)`
  margin-bottom: ${Spacings.SPACING_6B};
`;

const CareerPublicNotice = () => {
  return (
    <Wrapper>
      <StyledH2 as="h1">Public Notice</StyledH2>
      <P1>
        It has come to our notice that lately there are instances of individuals
        being approached for a role at Unacademy via unethical means. We would
        like to clarify that the activity in question is not authorised or
        conducted by Unacademy or any of its authorised employees. Unacademy is
        not, in any manner, associated with the individual in question and
        condemns this action and behaviour. Unacademy does not charge any kind
        of fee or deposits as part of its recruitment process.
        <br />
        <br />
        Unacademy will undertake all necessary actions and conduct an inquiry
        into the matter. We advise everyone to stay cautious and vigilant from
        imposters promising / offering jobs with Unacademy. Please undertake
        thorough due diligence before initiating any conversations or financial
        transactions in this regard.
      </P1>
    </Wrapper>
  );
};

CareerPublicNotice.pageInfo = {
  name: 'Careers - Public Notice',
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true
  },
  isMWebSupported: true
};

export default CareerPublicNotice;

export const getStaticProps = async () => {
  const props = {};
  return {
    props,
    revalidate: 5 * 60
  };
};

CareerPublicNotice.Layout = Layout;
CareerPublicNotice.Wrapper = PageReduxProvider;
